import { render, staticRenderFns } from "./MeterReadingPreviewMessageShimmer.vue?vue&type=template&id=6e76673e&"
import script from "./MeterReadingPreviewMessageShimmer.vue?vue&type=script&lang=js&"
export * from "./MeterReadingPreviewMessageShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports